var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTracklimo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 44,
    viewBox: "0 0 57 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2119 18.8993C11.0841 21.334 5.46026 26.4769 5.54192 30.7794C5.65138 36.5464 16.016 41.0242 28.6982 40.7835C41.3803 40.5428 51.5676 35.6749 51.4581 29.9079C51.3819 25.8905 46.307 21.3297 38.9476 19.0134C39.0913 18.7808 39.2341 18.5472 39.3758 18.313C49.5011 20.0827 56.6554 24.5021 56.7561 29.8073C56.8908 36.9044 44.351 42.8965 28.7439 43.1927C13.1368 43.4889 0.378599 37.977 0.243895 30.8799C0.137593 25.2793 7.92434 20.3668 18.8827 18.3986C18.9919 18.5659 19.1016 18.7328 19.2119 18.8993Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3427 30.1271C33.1724 26.2526 39.626 16.862 39.626 11.5873C39.626 5.19016 34.8823 0 29.0355 0C23.1886 0 18.4449 5.19016 18.4449 11.5873C18.4449 16.862 24.8985 26.2526 27.7282 30.1271C28.4067 31.0504 29.6643 31.0504 30.3427 30.1271ZM29.0355 15.4498C27.0884 15.4498 25.5053 13.7177 25.5053 11.5873C25.5053 9.45695 27.0884 7.72489 29.0355 7.72489C30.9826 7.72489 32.5656 9.45695 32.5656 11.5873C32.5656 13.7177 30.9826 15.4498 29.0355 15.4498Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9138 23.9163C18.2626 25.3374 15.0534 28.2889 15.1003 30.7609C15.1636 34.0983 21.1642 36.6896 28.5065 36.5503C35.8488 36.4109 41.7467 33.5938 41.6834 30.2564C41.6418 28.0645 39.0278 25.5931 35.1584 24.1942C35.2726 24.0314 35.3875 23.8668 35.5028 23.7008C40.9305 24.812 44.6951 27.2723 44.7506 30.1982C44.8286 34.3053 37.5686 37.773 28.533 37.9445C19.4973 38.116 12.111 34.9263 12.033 30.8192C11.9719 27.6006 16.417 24.7748 22.6917 23.6201C22.7659 23.7194 22.8399 23.8181 22.9138 23.9163Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracklimo);
export default __webpack_public_path__ + "static/media/tracklimo.80f68d6f94dc60f138a79583460c5fd9.svg";
export { ForwardRef as ReactComponent };